import { Reveal } from "@/components/common/Reveal";

export const PageHero = ({ eyebrow, title, intro, color = "bg-mint", testid, children }) => (
  <section className="relative overflow-hidden pt-10 pb-6" data-testid={testid}>
    <div className="container-x">
      <div className={`relative overflow-hidden rounded-[40px] ${color} px-7 py-14 sm:px-14 sm:py-20`}>
        <Reveal className="max-w-3xl">
          <p className="eyebrow">{eyebrow}</p>
          <h1 className="mt-6 text-5xl sm:text-6xl font-semibold leading-[1.02] tracking-tight">{title}</h1>
          {intro && <p className="mt-6 text-lg sm:text-xl leading-relaxed text-ink">{intro}</p>}
          {children}
        </Reveal>
      </div>
    </div>
  </section>
);
